import { Component } from "@angular/core";

@Component({
  selector: "evrideo-clipping-studio-root",
  template: `<router-outlet></router-outlet>`,
  styles: [`:host { display: block; width: 100%; height: 100vh; }`],
})
export class ClippingStudioRootComponent {}
